/**
 * stores/settings
 * flux reducer store for app settings
 */

import { ReduceStore } from 'flux/utils';

import dispatcher from '../dispatcher';

const INITIAL_STATE = {
  showIntro: true,
  weight: '',
};

class SettingsStore extends ReduceStore {
  getInitialState() {
    return {
      ...INITIAL_STATE,
    };
  }

  reduce(state, action) {
    const { type, data } = action;

    switch (type) {
      case 'INIT_SETTINGS':
      case 'SAVE_SETTINGS':
        return {
          ...state,
          ...data,
        };

      case 'HIDE_INTRO':
        return {
          ...state,
          showIntro: false,
        };

      case 'RESET_APP':
        return this.getInitialState();

      default:
        return state;
    }
  }
}

export default new SettingsStore(dispatcher);



// WEBPACK FOOTER //
// ./src/stores/settings.js